var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.planEnded)?_c('PlanEnded'):_c('div',{staticClass:"boxes videos vert-padded"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"box-container"},[_c('Box',{attrs:{"title":item.title,"thumb":_vm.itemThumb(item.video),"action-icon":_vm.itemActionIcon(item),"link":_vm.itemLink(item)}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }